import Module from 'mini-module-switcher/lib/schema/Module';
import { attachPeopleCardRoutes } from 'mini-people-card-route-store';
import { EMAIL_CONTEXT_BEGIN } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { emailContextValues } from './mailViewHandler';
import { getActiveReadingPanePath } from './getActiveReadingPanePath';
import { getCalendarEventViewRoutePath } from './getCalendarEventViewRoutePath';
import { getComposeStore } from 'mini-mail-compose-store/lib/store/composeStore';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { getMailPath } from 'owa-url';
import { getMailRoutePath } from 'mini-mail-route-store/lib/utils/getMailRoutePath';
import { getStore as getFolderStore } from 'mini-mail-folder-store/lib/store/Store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { signalWorkflowEvent } from 'mini-workflow-manager';

function getCurrentRoute(routePrefix?: string): string[] {
    if (emailContextValues.ECPath) {
        signalWorkflowEvent(
            EMAIL_CONTEXT_BEGIN,
            {
                f: 'getCurrentRoute', //limiting characters to save space
                u: window.location.href,
            },
            { isCore: true }
        );
    }

    const route = routePrefix ? [routePrefix] : [];
    const { mailModule } = getMailStore();

    switch (mailModule.selectedModule) {
        case Module.Feedback:
            route.push('feedback');
            break;
        case Module.Options:
            route.push('settings');
            mailModule.selectedSubRoute && route.push(mailModule.selectedSubRoute);
            mailModule.selectedSubRouteOption && route.push(mailModule.selectedSubRouteOption);
            break;
        case Module.Search:
            if (window.location.pathname.indexOf('search') === -1) {
                route.push('search');
            } else {
                // In search module, any store changes trigger getCurrentRoute which then pushes /search route causing a redirect to search autosuggestion page
                // The below code ensures that the route change due to react-router is preserved and no new routes are pushed by getCurrentRoute.
                window.location.pathname
                    .replace(getMailPath(), '')
                    .split('/')
                    .forEach(path => route.push(decodeURIComponent(path)));
            }
            break;
        default:
            if (
                !getFolderStore().showMoveToFolderPane &&
                !getMailStore().mailModule.selectedId &&
                getListViewStore().shouldShowSearchBox
            ) {
                route.push('search');
                return route;
            }

            const composeStore = getComposeStore();
            if (composeStore.defaultViewState) {
                route.push('compose');
                const viewState = composeStore.defaultViewState;
                if (viewState && viewState.itemId && viewState.itemId.Id) {
                    route.push(viewState.itemId.Id);
                }

                return route;
            }

            // Add the route paths for generic mail route construction
            // return on match to avoid false positive match in getActiveReadingPanePath
            const mailRoutePath = getMailRoutePath();
            if (mailRoutePath.length) {
                return route.concat(mailRoutePath);
            }

            // Folder selection
            // Add the params for the regular path to open reading pane
            route.push(...getActiveReadingPanePath());

            // Add the params for opening the event details when seen from mail reading pane
            route.push(...getCalendarEventViewRoutePath());
            break;
    }

    return route;
}

export default (routePrefix?: string) => attachPeopleCardRoutes(getCurrentRoute, routePrefix);
